import React, { FunctionComponent, ReactElement } from 'react';
import {
    Title,
    TitleSection,
    QuestionsToAskModalWrapper,
    CloseIcon,
    QuestionsToAskModalComponent,
    Description,
} from './Styles';

interface QuestionsToAskModalProps {
    closeScanDetails: () => void;
    title: string;
    descriptions?: string[];
    items?: string[];
    children?: ReactElement;
}

const QuestionsToAskModal: FunctionComponent<QuestionsToAskModalProps> = (
    props,
) => {
    const { closeScanDetails, title, items, descriptions, children } = props;

    return (
        <QuestionsToAskModalComponent onClick={closeScanDetails}>
            <QuestionsToAskModalWrapper onClick={(e) => e.stopPropagation()}>
                <TitleSection>
                    <Title>{title}</Title>
                    <CloseIcon onClick={closeScanDetails}>
                        <svg
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.8415 0.1587C15.6302 -0.0529 15.2546 -0.0529 15.0433 0.1587L8 7.21203L0.956713 0.1587C0.745414 -0.0529 0.369773 -0.0529 0.158474 0.1587C-0.0528247 0.3703 -0.0528247 0.746477 0.158474 0.958077L7.20176 8.0114L0.158474 15.0647C-0.0528247 15.2763 -0.0528247 15.6525 0.158474 15.8641C0.275862 15.9817 0.416728 16.0287 0.557593 16.0287C0.698459 16.0287 0.839325 15.9817 0.956713 15.8641L8 8.81078L15.0433 15.8641C15.1607 15.9817 15.3015 16.0287 15.4424 16.0287C15.5833 16.0287 15.7241 15.9817 15.8415 15.8641C16.0528 15.6525 16.0528 15.2763 15.8415 15.0647L8.79824 8.0114L15.8415 0.958077C16.0528 0.746477 16.0528 0.393811 15.8415 0.1587Z"
                                fill="#40596F"
                            />
                        </svg>
                    </CloseIcon>
                </TitleSection>
                {!!descriptions && descriptions.length !== 0 && (
                    <Description className="desc">
                        {descriptions.map((description, index) => {
                            return (
                                <div key={index}>
                                    <p>{description}</p>
                                </div>
                            );
                        })}
                    </Description>
                )}
                <Description>
                    {!!items &&
                        items.map((item, index) => {
                            return (
                                <li key={`question_item_${index}`}>
                                    <span>{item}</span>
                                </li>
                            );
                        })}
                    {!!children && children}
                </Description>
            </QuestionsToAskModalWrapper>
        </QuestionsToAskModalComponent>
    );
};
export default QuestionsToAskModal;
